import { useFeatureFlag } from "@src/features/app/hooks/useFeatureFlag";

const usePublishUpdatedContentFeatureFlag = (): boolean => {
  const featureFlagEnabled = useFeatureFlag("publish_updated_content");
  return featureFlagEnabled;
};

export default usePublishUpdatedContentFeatureFlag;
